
// This file is auto-generated. Do not edit directly.
// It combines all language configs into a single file.

import enConfig from '../../domains/app/translations/en.config.js';
import esConfig from '../../domains/app/translations/es.config.js';
import frConfig from '../../domains/app/translations/fr.config.js';

// Default config for languages without a specific config
const defaultConfig = {
    label: 'English',
    dateFormats: {
        LT: 'h:mm A',
        LTS: 'DD/MM/YYYY HH:mm',
        L: 'DD/MM/YYYY',
        LL: 'Do MMMM YYYY',
        LLL: 'Do MMMM YYYY LT',
        LLLL: 'dddd, MMMM Do YYYY LT',
    },
    thousandGroupStyle: 'thousand',
};

// Combine all language configs
export const LANGUAGE_CONFIGS = {
    en: {
                ...defaultConfig,
                ...enConfig,
                dateFormats: {
                    ...defaultConfig.dateFormats,
                    ...(enConfig.dateFormats || {}),
                },
            },
    es: {
                ...defaultConfig,
                ...esConfig,
                dateFormats: {
                    ...defaultConfig.dateFormats,
                    ...(esConfig.dateFormats || {}),
                },
            },
    fr: {
                ...defaultConfig,
                ...frConfig,
                dateFormats: {
                    ...defaultConfig.dateFormats,
                    ...(frConfig.dateFormats || {}),
                },
            }
};

export default LANGUAGE_CONFIGS;
